// extracted by css-extract-rspack-plugin
export default {"container":"ZHZHywo3ErGFVuZE","severity":"c27GJ9GjGiYRZ2uU"};